export default {
  header: {
    review_us: 'Notez-nous sur Google',
    upload: 'Déposer un avis Google',
    not_now: 'Pas maintenant',
  },
  steps: {
    how_it_works: 'Comment ça marche',
    step_1: {
      title: 'Étape',
      description: 'Rédigez un avis sur {{name}} sur Google',
    },
    step_2: {
      title: 'Étape',
      description: "Déposez une capture d'écran de votre avis publié (voir exemple ci-dessous)",
    },
  },
  buttons: {
    upload_screenshot: 'Télécharger la capture',
    leave_google_review: 'Laisser un avis Google',
    submit_screenshot: 'Soumettre la capture',
    return: 'Retour',
  },
  enter_name: {
    title: 'Nom publié avec votre avis Google',
    place_holder: 'Saisir le nom',
  },
  screenshot_uploaded: {
    title: 'Capture téléchargée',
    description: 'Faites défiler pour voir la capture complète',
  },
  loading: {
    processing: 'Votre avis publié est en cours de vérification',
  },
  error_messages: {
    upload_failed: 'Échec du téléchargement. Veuillez réessayer.',
    review_already_uploaded:
      "Il semble que vous ayez déjà déposé une capture d'un avis Google. Vous ne pouvez être récompensé qu'une seule fois 😊",
    name_missing: {
      description:
        'Veuillez saisir le nom utilisé pour votre avis Google afin que nous puissions valider votre identité.',
      button: {
        title: 'OK',
      },
    },
  },
};
